/** ECharts MapComponent 内部 roam zoom（可到上万）。大于等于则显示单点而非项目聚合。 */
export const CLUSTER_ZOOM_THRESHOLD = 100

export function stationLayerUpdateMode(previousZoom, nextZoom) {
  const previousIsDetail = Number.isFinite(previousZoom) && previousZoom >= CLUSTER_ZOOM_THRESHOLD
  const nextIsDetail = Number.isFinite(nextZoom) && nextZoom >= CLUSTER_ZOOM_THRESHOLD
  return previousIsDetail === nextIsDetail ? 'update' : 'replace'
}

export function isCurrentMapViewRevision(expectedRevision, currentRevision) {
  return expectedRevision === currentRevision
}

export function stationLayerUpdateOptions(previousZoom, nextZoom, center, series, completeOption) {
  if (stationLayerUpdateMode(previousZoom, nextZoom) === 'replace') {
    const nextGeo = {
      ...(completeOption?.geo || {}),
      center: [...center],
      zoom: nextZoom,
      animationDurationUpdate: 0
    }
    return {
      option: {
        ...(completeOption || {}),
        animation: false,
        geo: nextGeo,
        series: [{ ...series, animation: false }]
      },
      settings: { notMerge: true, lazyUpdate: false }
    }
  }

  return {
    option: { series: [{ id: series.id, data: series.data }] },
    settings: { notMerge: false, lazyUpdate: true }
  }
}

/**
 * 天地图 JS `map.getZoom()` 约 4–18。大于等于则显示单仪器点；小于则显示项目「总点」聚合（对齐 2D：zoom<100 聚合 / ≥100 单点）。
 * 项目聚焦 zoom 应始终小于本值，避免未放大就展开。
 */
export const TIANDITU_JS_DETAIL_ZOOM_THRESHOLD = 14

export function buildProjectClusters(stations = []) {
  if (!stations || stations.length === 0) return []

  const groups = {}
  stations.forEach((s) => {
    const projectId = s.project_id == null ? '' : String(s.project_id)
    if (!projectId) return
    if (!groups[projectId]) {
      groups[projectId] = {
        id: s.project_id,
        name: s.project_name || '未知项目',
        count: 0,
        lngSum: 0,
        latSum: 0,
        statusPriority: 0, // 0: normal, 1: warning, 2: error
        stations: [],
        eventCount: s.microseismic_event_count_24h
      }
    }
    const g = groups[projectId]
    g.count += 1
    g.lngSum += s.value?.[0] || 0
    g.latSum += s.value?.[1] || 0
    g.stations.push(s)

    // statusPriority: 0 normal, 1 yellow, 2 orange, 3 red
    let p = 0
    if (s.status === 'yellow') p = 1
    if (s.status === 'orange') p = 2
    if (s.status === 'red') p = 3
    if (p > g.statusPriority) g.statusPriority = p
  })

  const statusMap = { 0: 'normal', 1: 'yellow', 2: 'orange', 3: 'red' }
  return Object.values(groups).map((g) => ({
    name: `${g.name} (${g.count}个设备 · 近24小时微震 ${g.eventCount ?? '—'} 个)`,
    value: [g.lngSum / g.count, g.latSum / g.count, 50],
    status: statusMap[g.statusPriority],
    isCluster: true,
    projectId: g.id,
    projectName: g.name,
    eventCount: g.eventCount,
    children: g.stations
  }))
}

